<template>
  <div class="search-wrapper">
    <v-autocomplete
      single-line
      outlined
      color="grey"
      clearable
      cache-items
      dense
      v-model="select"
      :loading="loading"
      :items="items"
      item-text="displayname"
      item-value="displayname"
      :search-input.sync="search"
      return-object
      hide-no-data
      hide-details
      label="Find Facility, State, or Province"
      @click:clear="clearItem"
      append-icon="mdi-magnify"
    >
      <template slot="append-outer">
        <v-icon @click="goMapList">{{ iconMapList }}</v-icon>
        <v-icon v-if="isMobile" @click="goMapListMobile">{{
          iconMapListMobile
        }}</v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import IconList from '@/components/icons/icon-list.vue';
import IconMap from '@/components/icons/icon-map.vue';

import appConfig from '../config/appConfig';

export default {
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null
    };
  },
  computed: {
    ...mapGetters('filterData', ['searchables']),
    ...mapGetters(['currentView']),
    ...mapGetters({
      selectedItemValue: 'mapTemplate/selectedItemValue',
      isMobile: 'mapTemplate/isMobile'
    }),
    iconMapList() {
      if (this.isMobile) {
        return '$vuetify.icons.nexmap';
      }
      // previously 'mdi-format-list-bulleted-type' : 'mdi-map-outline';
      // custom svg icons specified in plugins/vuetify.js
      return this.currentView === 'MapView' || !this.currentView
        ? '$vuetify.icons.nexlist'
        : '$vuetify.icons.nexmap';
    },
    iconMapListMobile() {
      if (this.isMobile) {
        if (this.isMobile) {
          return '$vuetify.icons.nexlist';
        }
      }
      return null;
    }
  },
  methods: {
    ...mapActions({
      selectItem: 'mapTemplate/selectItem'
    }),
    ...mapMutations(['setCurrentView', 'toggleDrawer', 'showList']),
    goMapList() {
      if (this.isMobile) {
        this.toggleDrawer(false);
        this.setCurrentView('MapView');
        return;
      }
      if (this.currentView == 'MapView') {
        this.setCurrentView('ListView');
      } else {
        this.setCurrentView('MapView');
      }
    },
    goMapListMobile() {
      this.showList();
      //this.setCurrentView('ListView');
    },
    querySelections(val) {
      this.loading = true;
      this.items = this.searchables.filter((e) => {
        return (
          (e.displayname || '')
            .toLowerCase()
            .indexOf((val || '').toLowerCase()) !== -1
        );
      });
      this.loading = false;
    },
    clearItem() {
      this.selectItem({
        value: appConfig.countriesApiProps.globalCountryValue,
        type: 'Country'
      });
    },
    findItem() {
      this.selectItem({
        value: this.select.displayname,
        type: this.select.type
      });
      this.setCurrentView('MapView');
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    select() {
      if (this.select) {
        this.findItem();
      }
    },
    selectedItemValue() {
      if (this.select && this.selectedItemValue !== this.select.displayname) {
        this.select = null;
      }
    }
  }
};
</script>

<style lang="scss">
.theme--light.v-list-item .v-list-item__mask {
  color: rgba(0, 0, 0, 1) !important;
  background: transparent !important;
  font-weight: bold;
}
#icon-list[type='button'],
#icon-map[type='button'] {
  height: 30px;
  appearance: none;
}
.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: rotate(0deg) !important;
}
.search-wrapper {
  width: 100%;
}
.v-icon--is-component {
  padding-right: 5px;
}
</style>
